import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { api, resolveImg } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { fmt, PAYMENT_METHODS } from "@/lib/site";

// CATÁLOGO REVISTA · Maderas La Romanilla · formato Casa Beline
// 7 páginas editoriales (spread panel de texto + foto héroe full-bleed),
// cada familia con destacadas A/B/C + tira de recortes alfa (sin halo,
// catalogo/recorte/*.png en R2). Los 47 best sellers con precio están
// todos en página; precios vivos del panel; AGREGAR alimenta el carrito
// real y el pedido llega al panel de control.
const IMG = (p) => resolveImg("/api/products/image/maderas-la-rola/" + p);

const PAGINAS = [
    {
        folio: "01", badge: "Seguridad", sello: "Cerraduras",
        titulo: ["La ", "cerradura."],
        dice: "Lo que cierra una casa pasa por aquí: de la ovalada de gaveta a la manilla de lujo. Las que más se llevan de la tienda, de Gato Ideace y Duralock.",
        famSkus: ["CER-1550", "CERPOMO1", "CER361", "CER-784", "CER-DURALOCK381"],
        panel: { c1: "#E3C49C", c2: "#D1AE86", c3: "#B98F60", hondo: "#5C3E28" },
        hero: "stills/p26-s2.jpg", heroAlt: "Manilla Duralock 381 sobre puerta de nogal", heroPos: "50% 45%",
        destacadas: [
            { sku: "CER361", nombre: "Manija 361 · Gato Ideace", chip: "#C6C7C9", puesto: "productos/29c96b5f-3a3c-4023-a243-bc68f3547a06.jpg", pos: "62% 50%" },
            { sku: "CER-DURALOCK381", nombre: "Manilla de lujo · Duralock 381", chip: "#B5A88F", puesto: "stills/p26-s1.jpg", pos: "58% 42%" },
            { sku: "CERPOMO1", nombre: "Pomo de acero inoxidable", chip: "#CDCED0", puesto: "productos/e29a4511-f60f-45ab-8dd3-607a443f7fe5.jpg", pos: "50% 45%" },
        ],
        tiraTitulo: "Más cerraduras y herrajes",
        tira: [
            { sku: "CER-1550", nombre: "Ovalada Gato 1550", chip: "#C6C7C9" },
            { sku: "CER-784", nombre: "Pico de loro Gato 784/785", chip: "#C6C7C9" },
            { sku: "MUELLE-JUSTOR", nombre: "Muelle pernio Justor", chip: "#D8D8DA" },
            { sku: "BIS078", nombre: 'Bisagra Omega 3" Induma', chip: "#C9CACC" },
            { sku: "BIS333", nombre: "Juego de bisagras 3×3 Induma", chip: "#C9CACC" },
            { sku: "CONDIMENTERO", nombre: "Condimentero extraíble · 15 cm", chip: "#D8D8DA" },
        ],
    },
    {
        folio: "02", badge: "Puertas", sello: "Puertas y marcos",
        titulo: ["La ", "puerta."],
        dice: "Entamboradas de okume y cedrillo, la ruteada Sofía y la semimaciza con diseño en V. Medidas 70–90 × 2.10, con su marco de cedro y los clavos para instalarla.",
        famSkus: ["PUE-LISA", "PUE-NOGAL", "PUE-RUTEADA", "PUE-SEMI-V", "LISTONES"],
        panel: { c1: "#C0B3A6", c2: "#A29283", c3: "#7D6F62", hondo: "#4E453D" },
        hero: "stills/p33-s3.jpg", heroAlt: "Puerta semimaciza con diseño en V en la entrada", heroPos: "50% 40%",
        destacadas: [
            { sku: "PUE-LISA", nombre: "Entamborada okume · 79-90 × 2.10", chip: "#D9B584", puesto: "stills/p32-s1.jpg", pos: "50% 35%" },
            { sku: "PUE-RUTEADA", nombre: "Modelo Sofía · 80 × 2.10", chip: "#C89A6B", puesto: "stills/p34-s1.jpg", pos: "50% 35%" },
            { sku: "PUE-SEMI-V", nombre: "Semimaciza diseño en V · 70-80", chip: "#B9AFA2", puesto: "stills/p33-s1.jpg", pos: "50% 35%" },
        ],
        tiraTitulo: "Más para la instalación",
        tira: [
            { sku: "PUE-NOGAL", nombre: "Entamborada cedrillo · 70-90 × 2.10", chip: "#8B5F3C" },
            { sku: "LISTONES", nombre: "Marco de madera de cedro", chip: "#C89A6B" },
            { sku: "CLAVOS-F20", nombre: "Clavos neumáticos · desde", chip: "#B9BCBE" },
        ],
    },
    {
        folio: "03", badge: "Tableros", sello: "Tableros y láminas",
        titulo: ["El ", "tablero."],
        dice: "MDF resistente a la humedad y chapas de castaño y okume en 122×244: la base de todo mueble que sale del taller.",
        famSkus: ["MDF-HR", "CHAPILLA", "CHAPILLA-OKUME"],
        panel: { c1: "#EBD1BA", c2: "#D0AF92", c3: "#9F7F66", hondo: "#634F40" },
        hero: "stills/g04-s2.jpg", heroAlt: "Chapa de castaño trabajada con rodillo", heroPos: "50% 40%",
        destacadas: [
            { sku: "MDF-HR", nombre: "MDF HR 18 mm · 122×244", chip: "#9EB39B", puesto: "stills/g02-s2.jpg", pos: "50% 40%" },
            { sku: "CHAPILLA", nombre: "Chapa de castaño · 122×244", chip: "#8B5A2B", puesto: "stills/g04-s3.jpg", pos: "50% 50%" },
            { sku: "CHAPILLA-OKUME", nombre: "Chapa de okume · 122×244", chip: "#C08552", puesto: "stills/g04-s1.jpg", pos: "50% 50%" },
        ],
        tira: [],
    },
    {
        folio: "04", badge: "Colas y pegas", sello: "Químicos",
        titulo: ["La ", "cola."],
        dice: "Blanca de alta resistencia, rosada de secado rápido y las de contacto para fórmica y chapilla. De la botella al galón.",
        famSkus: ["COL-PHIL-GL", "COL-PREM-GL", "PEG012", "PEG050", "PEG-5000-GL", "PEG-9000-GL", "PEG-FIX-CANO", "PEG-PLUS-GL"],
        panel: { c1: "#DEB693", c2: "#B6865F", c3: "#7C5335", hondo: "#4E3421" },
        hero: "stills/p16-s1.jpg", heroAlt: "Cola blanca Pegaphil en el banco de trabajo", heroPos: "50% 45%",
        destacadas: [
            { sku: "COL-PHIL-GL", nombre: "Cola blanca Pegaphil · galón", chip: "#F0EDE6", puesto: "stills/p16-s2.jpg", pos: "50% 45%" },
            { sku: "COL-PREM-GL", nombre: "Rosada secado rápido Premacol · galón", chip: "#E8909E", puesto: "stills/p25-s1.jpg", pos: "50% 45%" },
            { sku: "PEG-9000-GL", nombre: "Contacto 9000 extra fuerte · galón", chip: "#E8A13B", puesto: "stills/p28-s2.jpg", pos: "50% 45%" },
        ],
        tiraTitulo: "Más colas y pegas",
        tira: [
            { sku: "PEG012", nombre: "Pega blanca Pegaphil", chip: "#F0EDE6" },
            { sku: "PEG050", nombre: "Premacol 50 secado rápido", chip: "#E8752B" },
            { sku: "PEG-5000-GL", nombre: "Contacto 5000 · galón", chip: "#E8A13B" },
            { sku: "PEG-FIX-CANO", nombre: "Pegalón Fix Cano · galón", chip: "#E8C93B" },
            { sku: "PEG-PLUS-GL", nombre: "Pegaplus madera · galón", chip: "#EAD9A8" },
        ],
    },
    {
        folio: "05", badge: "Selladores", sello: "Silicones y masillas",
        titulo: ["El ", "sellador."],
        dice: "Silicones para cada junta, el sellador acrílico de siempre y la masilla que se lija fino; con el thinner y el tinte para preparar la pieza.",
        famSkus: ["SEL-ACR-ZASC", "SEL-VENT-CANO", "SIL-BLA-ZASC", "SIL-HD-TIT", "SIL-NEG-ZASC", "SIL-WALLPANEL", "MAS-POLIFLEX", "THI-ACR-GL", "THI-PC25-GL", "TIN-NEG-14"],
        panel: { c1: "#FCD39E", c2: "#E4B47E", c3: "#B08763", hondo: "#6E543E" },
        hero: "stills/p07-s2.jpg", heroAlt: "Silicón Heavy Duty Titebond en pistola sobre madera", heroPos: "50% 50%",
        destacadas: [
            { sku: "SIL-HD-TIT", nombre: "Heavy Duty construcción · Titebond", chip: "#C8A24B", puesto: "stills/p07-s1.jpg", pos: "50% 50%" },
            { sku: "SEL-ACR-ZASC", nombre: "Sellador acrílico ZASC", chip: "#2E2C2A", puesto: "stills/p08-s2.jpg", pos: "50% 50%" },
            { sku: "MAS-POLIFLEX", nombre: "Masilla plástica Poliflex · 1/4", chip: "#4B4F55", puesto: "stills/p17-s2-fix.jpg", pos: "50% 45%" },
        ],
        tiraTitulo: "Más selladores y preparación",
        tira: [
            { sku: "SEL-VENT-CANO", nombre: "Windows Plus para ventanas", chip: "#3B5C9E" },
            { sku: "SIL-BLA-ZASC", nombre: "Silicón blanco ZASC", chip: "#F0EDE6" },
            { sku: "SIL-NEG-ZASC", nombre: "Silicón negro ZASC", chip: "#2E2C2A" },
            { sku: "SIL-WALLPANEL", nombre: "Blanco especial Wall Panel", chip: "#E8E4DC" },
            { sku: "THI-ACR-GL", nombre: "Thinner acrílico · galón", chip: "#D8DCE0" },
            { sku: "THI-PC25-GL", nombre: "Solvente PC-25 · galón", chip: "#9EB8D8" },
            { sku: "TIN-NEG-14", nombre: "Tinte negro para madera · 1 L", chip: "#2E2C2A" },
        ],
    },
    {
        folio: "06", badge: "Acabados", sello: "Lacas y barnices",
        titulo: ["El ", "acabado."],
        dice: "Del barniz marino a la laca blanca y el poliuretano 2K con su catalizador: el brillo con el que la pieza sale del taller.",
        famSkus: ["BAR-URE-QUI", "DUR-2K-KIT", "FON-PU-1K", "LAC-ACR-14", "LAC-BLA-GL", "LAC-TRA-14", "SEL-CONC-14", "SEL-NITRO-GL"],
        panel: { c1: "#C8C3C3", c2: "#A39991", c3: "#756658", hondo: "#494037" },
        hero: "stills/p29-s2.jpg", heroAlt: "Kit poliuretano 2K Durano sobre madera barnizada", heroPos: "50% 45%",
        destacadas: [
            { sku: "LAC-BLA-GL", nombre: "Laca blanca brillante Laacril · galón", chip: "#F2EFEA", puesto: "stills/p20-s1.jpg", pos: "50% 45%" },
            { sku: "DUR-2K-KIT", nombre: "Poliuretano 2K Durano · galón + catalizador", chip: "#E8E4DC", puesto: "stills/p29-s1.jpg", pos: "50% 45%" },
            { sku: "LAC-ACR-14", nombre: "Laca acrílica Auto-Cryl · 1/4", chip: "#34433C", puesto: "stills/p21-s1.jpg", pos: "50% 45%" },
        ],
        tiraTitulo: "Más acabados",
        tira: [
            { sku: "BAR-URE-QUI", nombre: "Barniz marino uretanizado · 1/4", chip: "#E8D84B" },
            { sku: "FON-PU-1K", nombre: "Fondo blanco PU 1K Maxlaac", chip: "#2E4B9E" },
            { sku: "LAC-TRA-14", nombre: "Laca transparente brillante · 1/4", chip: "#E8E4DC" },
            { sku: "SEL-CONC-14", nombre: "Sellador concentrado · 1/4", chip: "#C8B99E" },
            { sku: "SEL-NITRO-GL", nombre: "Sellador nitro · galón", chip: "#B08763" },
        ],
    },
    {
        folio: "07", badge: "Eléctricos", sello: "Luz para muebles",
        titulo: ["La ", "luz."],
        dice: "Cinta LED de 5 metros en luz cálida o blanca, con su transformador de 60 W y el sensor touch: la luz que remata el mueble.",
        famSkus: ["LED-COB-6500K", "FTE-LED-60W", "KIT-LED-CON"],
        panel: { c1: "#E4CAA6", c2: "#C59F73", c3: "#926944", hondo: "#5B422A" },
        hero: "stills/p38-s2.jpg", heroAlt: "Luz LED cálida bajo el gabinete de cocina", heroPos: "50% 50%",
        destacadas: [
            { sku: "LED-COB-6500K", nombre: "Cinta LED 12V · rollo 5 m", chip: "#F5EDD8", puesto: "stills/p37-s1.jpg", pos: "50% 45%" },
            { sku: "FTE-LED-60W", nombre: "Transformador 12V · 60 W", chip: "#2A2A2C", puesto: "stills/p38-s1.jpg", pos: "50% 45%" },
            { sku: "KIT-LED-CON", nombre: "Sensor touch 12V", chip: "#E4E4E6", puesto: "stills/p36-s2.jpg", pos: "50% 40%" },
        ],
        tira: [],
    },
];

export default function CatalogoBestSellers() {
    const [porSku, setPorSku] = useState({});
    const [agregado, setAgregado] = useState({});
    const { addItem, setOpen, count, subtotal, items, updateQty, removeItem, unitPrice } = useCart();
    const [verCarrito, setVerCarrito] = useState(false);
    const nav = useNavigate();

    useEffect(() => {
        document.title = "Catálogo · Maderas La Romanilla";
        if (window.fbq) window.fbq("track", "ViewContent", { content_type: "product_group", content_name: "catalogo-revista" });
        api.get("/products", { params: { etiqueta: "BEST SELLER", limit: 100 } })
            .then((r) => {
                const m = {};
                (r.data.items || []).forEach((p) => { m[p.sku] = p; });
                setPorSku(m);
            })
            .catch(() => {});
    }, []);

    const agregar = (p) => {
        if (!p) return;
        addItem(p, 1);
        setOpen(false); // sin drawer: la barra de abajo lleva el pedido
        if (window.fbq) window.fbq("track", "AddToCart", { content_ids: [p.sku], content_type: "product", value: p.precio_usd, currency: "USD" });
        setAgregado((a) => ({ ...a, [p.sku]: true }));
        setTimeout(() => setAgregado((a) => ({ ...a, [p.sku]: false })), 1400);
    };

    const botonAgregar = (p) => (
        <button className={`c1-mas${agregado[p?.sku] ? " ok" : ""}`} type="button" onClick={() => agregar(p)} data-testid={`c1-agregar-${p?.sku}`}>
            {agregado[p?.sku] ? "Agregado ✓" : "Agregar"}
        </button>
    );

    const rangoDe = (skus) => {
        const v = skus.map((s) => porSku[s]?.precio_usd).filter((x) => x != null);
        if (!v.length) return "—";
        return `${fmt(Math.min(...v))} – ${fmt(Math.max(...v))}`;
    };

    // el índice manda: el cliente salta directo a su familia, cero recorrido.
    // El scroll va por Lenis (window.__lenis): scrollIntoView pelea contra su
    // target interno y el salto termina en cualquier lado.
    const irA = (folio) => {
        const el = document.getElementById(`pag-${folio}`);
        if (!el) return;
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -42 });
        else el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        // con la barra visible, el pie necesita aire: si no, la barra fija
        // tapa los AGREGAR de la última fila
        <div className="c1-root" style={count > 0 ? { paddingBottom: "calc(96px + env(safe-area-inset-bottom))" } : undefined}>
            <style>{`
.c1-root{--verde:#1E4D2B;--verde-hondo:#0e2a17;--naranja:#D96A1F;--madera:#d99f5e;
--crema:#F5F4EC;--hueso:#fffdf8;--tinta:#2E1D10;--humo:#7a6a58;
font-family:Manrope,Inter,-apple-system,sans-serif;background:var(--verde-hondo);
color:var(--tinta);line-height:1.5;-webkit-font-smoothing:antialiased;overflow-x:hidden}
.c1-root img{display:block;max-width:100%}
.c1-root button{font-family:inherit}
.c1-eti{font-size:9.5px;letter-spacing:.32em;text-transform:uppercase;font-weight:700}

/* La página · dos paneles: tipografía AL LADO de la foto, como catálogo
   impreso. Los tonos del panel salen de la propia foto héroe (--pc1..3). */
.c1-pag{position:relative;display:grid;grid-template-columns:minmax(0,46fr) minmax(0,54fr);
min-height:min(94svh,880px);background:var(--pc2)}
.c1-txt-panel{position:relative;overflow:hidden;
background:linear-gradient(152deg,var(--pc1) 0%,var(--pc2) 44%,var(--pc3) 100%);
padding:clamp(22px,3vw,44px) clamp(20px,3.2vw,52px);
display:flex;flex-direction:column;gap:clamp(12px,1.6vw,20px)}
.c1-txt-panel::before{content:"";position:absolute;inset:0;pointer-events:none;
background:linear-gradient(118deg,rgba(255,240,220,.32) 0%,rgba(255,240,220,.10) 26%,
rgba(255,240,220,0) 46%)}
.c1-txt-panel>*{position:relative;z-index:2}
/* el lomo del catálogo abierto: sombra corta hacia la página de imagen */
.c1-img-panel{position:relative;overflow:hidden;background:var(--phondo)}
.c1-img-panel::before{content:"";position:absolute;left:0;top:0;bottom:0;width:34px;
z-index:2;pointer-events:none;
background:linear-gradient(90deg,rgba(40,22,12,.38) 0%,rgba(40,22,12,.10) 40%,
rgba(40,22,12,0) 100%)}
@media(max-width:900px){.c1-img-panel::before{display:none}}
.c1-foto{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}

.c1-cabeza{display:flex;justify-content:space-between;align-items:flex-start;gap:16px}
.c1-badge{background:var(--verde);color:var(--madera);border-radius:40px;
padding:9px 20px;font-size:10.5px;letter-spacing:.26em;text-transform:uppercase;
font-weight:800;box-shadow:0 8px 22px rgba(14,42,23,.28)}
.c1-sello{background:var(--hueso);border-radius:4px;padding:10px 16px;text-align:right;
box-shadow:0 8px 22px rgba(14,42,23,.16)}
.c1-sello b{display:block;font-size:9.5px;letter-spacing:.3em;text-transform:uppercase;
color:var(--naranja);font-weight:800}
.c1-sello span{display:block;font-size:18px;font-weight:200;letter-spacing:-.02em;
color:var(--verde-hondo);margin-top:2px}

.c1-txt{flex:1;display:flex;flex-direction:column;justify-content:center;min-width:0}
.c1-txt h1{font-weight:200;font-size:clamp(40px,6.2vw,76px);line-height:.88;
letter-spacing:-.05em;color:var(--verde-hondo)}
.c1-txt h1 em{font-style:normal;font-weight:700}
.c1-dice{font-weight:400;font-size:clamp(12.5px,1.35vw,14px);line-height:1.55;
color:rgba(46,29,16,.82);margin-top:clamp(9px,1.2vw,14px)}
.c1-disp{font-size:11px;font-weight:700;color:var(--verde);margin-top:8px;
letter-spacing:.03em;font-variant-numeric:tabular-nums}
.c1-ref{margin-top:clamp(11px,1.6vw,18px)}
.c1-ref b{display:block;font-size:10.5px;letter-spacing:.2em;font-weight:800;
color:var(--verde-hondo);margin-bottom:2px}
.c1-ref span{display:block;white-space:nowrap;font-weight:700;
font-size:clamp(26px,3.6vw,42px);letter-spacing:-.04em;line-height:1.05;
color:var(--verde-hondo);font-variant-numeric:tabular-nums}
.c1-ref i{font-style:normal;display:block;font-size:10.5px;font-weight:500;
color:rgba(46,29,16,.62);margin-top:4px}

/* lista A/B/C · las tres destacadas con su código y su AGREGAR */
.c1-lista{margin-top:clamp(12px,1.8vw,18px);display:flex;flex-direction:column;gap:7px}
.c1-li{display:flex;align-items:center;flex-wrap:wrap;gap:9px;
background:rgba(255,253,248,.9);border-radius:3px;padding:6px 9px 6px 6px}
.c1-let{width:22px;height:22px;flex:0 0 22px;border-radius:50%;
background:var(--verde-hondo);color:var(--madera);display:flex;align-items:center;
justify-content:center;font-size:10px;font-weight:700}
.c1-chip{width:22px;height:22px;flex:0 0 22px;border-radius:50%;
box-shadow:inset 0 0 0 1px rgba(46,29,16,.2)}
.c1-dat{flex:1;min-width:0}
.c1-dat b{display:block;font-size:11.5px;font-weight:600;line-height:1.2;
color:var(--verde-hondo)}
.c1-dat span{display:block;font-size:8.5px;color:var(--humo);font-weight:600;
letter-spacing:.06em;margin-top:2px;font-variant-numeric:tabular-nums;
overflow-wrap:anywhere}
.c1-iva{font-size:9px;font-weight:700;letter-spacing:.04em;color:var(--humo);margin-left:4px;white-space:nowrap}
.c1-pre{font-size:13px;font-weight:700;letter-spacing:-.02em;color:var(--verde-hondo);
font-variant-numeric:tabular-nums}
.c1-mas{flex:0 0 auto;border-radius:30px;border:none;background:var(--naranja);
color:#fff;cursor:pointer;font-size:9.5px;font-weight:800;letter-spacing:.13em;
text-transform:uppercase;padding:8px 13px;line-height:1;
transition:background .2s,transform .18s;white-space:nowrap}
.c1-mas:hover{background:var(--verde-hondo);transform:translateY(-1px)}
.c1-mas.ok{background:var(--verde-hondo)}

/* el producto puesto · fila A/B/C al pie del panel de texto */
.c1-puestos{display:grid;grid-template-columns:repeat(3,1fr);gap:clamp(7px,1vw,11px)}
.c1-pu{position:relative;border-radius:3px;overflow:hidden;
box-shadow:0 12px 30px rgba(40,22,12,.30)}
.c1-pu img{width:100%;aspect-ratio:.92;object-fit:cover}
.c1-pu-let{position:absolute;left:0;top:0;width:23px;height:23px;
background:var(--verde-hondo);color:var(--madera);display:flex;align-items:center;
justify-content:center;font-weight:700;font-size:10px;border-radius:0 0 3px 0}
.c1-folio{position:absolute;right:clamp(14px,2vw,26px);bottom:clamp(10px,1.6vw,20px);
z-index:2;font-size:11px;font-weight:700;color:rgba(255,255,255,.72);
font-variant-numeric:tabular-nums}

@media(max-width:900px){
  .c1-pag{grid-template-columns:1fr;min-height:0}
  .c1-img-panel{order:-1;aspect-ratio:1.24}
  .c1-txt-panel{padding:20px 18px 22px}
}

/* cómo funciona · el pedido llega al panel y se confirma por WhatsApp */
.c1-como{background:var(--verde);color:var(--crema);padding:clamp(22px,3.2vw,40px) 0}
.c1-como-in{max-width:1300px;margin:0 auto;padding:0 clamp(20px,4vw,56px);
display:grid;grid-template-columns:auto 1fr;gap:clamp(18px,3vw,44px);align-items:center}
.c1-como-in .c1-eti{color:#C8873F;margin-bottom:7px;display:block}
.c1-como-in h3{font-weight:200;font-size:clamp(20px,3vw,32px);line-height:1.08;
letter-spacing:-.03em}
.c1-como-in h3 em{font-style:normal;font-weight:700;color:var(--madera)}
.c1-como-in p{font-weight:300;font-size:13px;opacity:.86;line-height:1.62;
max-width:46ch;margin-top:8px}
.c1-pagos{display:flex;flex-wrap:wrap;gap:6px}
.c1-pagos span{border:1px solid rgba(217,159,94,.45);color:var(--madera);font-size:11.5px;
font-weight:500;padding:6px 10px;border-radius:20px}
@media(max-width:760px){.c1-como-in{grid-template-columns:1fr}}

/* tira · recortes con transparencia sobre el papel de la página */
.c1-tira{background:var(--crema);padding:clamp(26px,4vw,52px) 0 clamp(40px,6vw,72px)}
.c1-tira-cab{max-width:1300px;margin:0 auto clamp(16px,2.4vw,24px);
padding:0 clamp(20px,4vw,56px) 13px;display:flex;justify-content:space-between;
align-items:baseline;gap:16px;border-bottom:1px solid rgba(30,77,43,.14)}
.c1-tira-cab .c1-eti{color:var(--naranja)}
.c1-tira-cab a{font-size:11px;font-weight:600;color:var(--verde);text-decoration:none}
.c1-tira-cab a:hover{color:var(--naranja)}
.c1-rej{max-width:1300px;margin:0 auto;padding:0 clamp(20px,4vw,56px);
display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));
gap:clamp(12px,1.8vw,22px)}
@media(min-width:1000px){.c1-rej{grid-template-columns:repeat(auto-fit,minmax(170px,196px));justify-content:center}}
.c1-pz{display:flex;flex-direction:column;min-width:0}
/* caja de tamaño FIJO con la imagen absoluta adentro: el recorte alto/flaco
   no puede reventar la celda ni desalinear la grilla (uniformidad) */
.c1-pz-img{position:relative;aspect-ratio:1.05;min-height:0;overflow:hidden}
.c1-pz-img img{position:absolute;inset:0;margin:auto;max-width:82%;max-height:88%;
width:auto;height:auto;
filter:drop-shadow(0 6px 5px rgba(40,22,12,.3));
transition:transform .5s cubic-bezier(.2,.7,.3,1)}
.c1-pz:hover .c1-pz-img img{transform:scale(1.05)}
.c1-pz-pie{display:flex;flex-direction:column;flex:1;
border-top:1px solid rgba(30,77,43,.14);padding-top:9px}
.c1-pz-col{display:flex;align-items:flex-start;gap:7px;font-size:10px;font-weight:700;
letter-spacing:.05em;color:var(--verde-hondo);line-height:1.3;min-height:2.7em}
.c1-pz-col i{margin-top:1px}
.c1-pz-col i{width:13px;height:13px;border-radius:50%;flex:0 0 13px;
box-shadow:inset 0 0 0 1px rgba(46,29,16,.2)}
.c1-pz-ref{font-size:8.5px;color:var(--humo);font-weight:600;letter-spacing:.06em;
margin-top:4px;font-variant-numeric:tabular-nums;overflow-wrap:anywhere}
.c1-pz-fila{display:flex;align-items:center;gap:8px;margin-top:auto;padding-top:9px}
.c1-pz-pre{font-size:14px;font-weight:700;letter-spacing:-.02em;margin-right:auto;
font-variant-numeric:tabular-nums;color:var(--verde-hondo)}

/* portada · el índice manda: de aquí se salta directo a cada familia */
.c1-portada{background:var(--verde-hondo);color:var(--crema);
padding:clamp(30px,5vw,64px) 0 clamp(20px,3vw,36px)}
.c1-portada-in{max-width:1300px;margin:0 auto;padding:0 clamp(20px,4vw,56px)}
.c1-portada .c1-eti{color:var(--madera)}
.c1-portada h1{font-weight:200;font-size:clamp(34px,5vw,58px);letter-spacing:-.04em;
line-height:.95;margin-top:10px}
.c1-portada h1 em{font-style:normal;font-weight:700;color:var(--madera)}
.c1-portada .sub{font-size:13px;opacity:.75;margin-top:10px;max-width:52ch;font-weight:300}
.c1-indice{margin-top:clamp(18px,3vw,30px);border-top:1px solid rgba(217,159,94,.25);
display:flex;flex-direction:column}
.c1-ind{display:flex;align-items:center;gap:clamp(10px,2vw,20px);width:100%;text-align:left;
background:none;border:none;border-bottom:1px solid rgba(217,159,94,.25);color:var(--crema);
padding:clamp(12px,1.8vw,18px) 2px;cursor:pointer;transition:background .2s}
.c1-ind:hover{background:rgba(217,159,94,.07)}
.c1-ind .n{font-weight:200;font-size:clamp(22px,3vw,34px);letter-spacing:-.04em;
color:var(--madera);font-variant-numeric:tabular-nums;width:clamp(36px,4vw,54px);flex:0 0 auto}
.c1-ind .t{flex:1;min-width:0}
.c1-ind .t b{display:block;font-size:clamp(15px,1.8vw,20px);font-weight:600;letter-spacing:-.01em}
.c1-ind .t span{display:block;font-size:11px;opacity:.62;margin-top:1px}
.c1-ind .r{font-size:clamp(12px,1.4vw,15px);font-weight:700;color:var(--madera);
font-variant-numeric:tabular-nums;white-space:nowrap}
.c1-ind .fl{color:var(--madera);opacity:.7;font-size:16px}

/* barra fija · cualquier familia a un toque, sin recorrer la revista */
.c1-nav{position:sticky;top:0;z-index:55;background:rgba(14,42,23,.96);
backdrop-filter:blur(6px);display:flex;gap:6px;overflow-x:auto;
padding:9px clamp(14px,3vw,28px);scrollbar-width:none}
.c1-nav::-webkit-scrollbar{display:none}
.c1-nav button{flex:0 0 auto;background:none;border:1px solid rgba(217,159,94,.4);
color:var(--madera);border-radius:20px;padding:6px 12px;font-size:10px;font-weight:700;
letter-spacing:.08em;text-transform:uppercase;cursor:pointer;white-space:nowrap;
transition:background .2s,color .2s}
.c1-nav button:hover{background:var(--madera);color:var(--verde-hondo)}

/* cierre · pie de la revista */
.c1-fin{background:var(--verde-hondo);color:var(--crema);text-align:center;
padding:clamp(30px,5vw,56px) 20px}
.c1-fin b{display:block;font-weight:200;font-size:clamp(22px,3vw,34px);
letter-spacing:-.03em}
.c1-fin b em{font-style:normal;font-weight:700;color:var(--madera)}
.c1-fin p{font-size:12.5px;opacity:.72;margin-top:8px}
.c1-fin a{display:inline-block;margin-top:16px;background:var(--naranja);color:#fff;
text-decoration:none;border-radius:30px;padding:12px 26px;font-size:11px;
font-weight:800;letter-spacing:.14em;text-transform:uppercase}

/* barra de pedido · aparece al agregar y lleva al checkout real */
.c1-barra{position:fixed;left:0;right:0;bottom:0;z-index:60;background:var(--verde-hondo);
color:var(--crema);display:flex;align-items:center;gap:14px;
padding:12px clamp(18px,4vw,48px);
padding-bottom:calc(12px + env(safe-area-inset-bottom))}
.c1-barra .c1-tot{font-weight:500;font-size:18px;font-variant-numeric:tabular-nums;
letter-spacing:-.025em}
.c1-barra .c1-cnt{font-size:11px;opacity:.6;font-weight:300}
.c1-barra .c1-ir{margin-left:auto;border:1px solid var(--madera);background:none;
color:var(--madera);font-weight:700;font-size:10px;letter-spacing:.2em;
text-transform:uppercase;padding:12px 22px;border-radius:30px;cursor:pointer}
.c1-barra .c1-ir:hover{background:var(--madera);color:var(--verde-hondo)}
/* el resumen se abre desde la barra: agregar sin poder quitar es una trampa */
.c1-barra .c1-ver{background:none;border:none;color:var(--madera);cursor:pointer;
font-size:11px;font-weight:700;letter-spacing:.06em;text-decoration:underline;
padding:2px 0;text-align:left}
.c1-panel{position:fixed;left:0;right:0;bottom:0;z-index:61;background:var(--crema);
color:var(--tinta);border-radius:16px 16px 0 0;box-shadow:0 -14px 40px rgba(14,42,23,.3);
max-height:min(72vh,560px);display:flex;flex-direction:column}
.c1-panel-cab{display:flex;align-items:center;justify-content:space-between;gap:12px;
padding:14px clamp(16px,4vw,28px);border-bottom:1px solid rgba(30,77,43,.14)}
.c1-panel-cab b{font-size:15px;font-weight:700;color:var(--verde-hondo)}
.c1-panel-cab button{background:none;border:none;cursor:pointer;font-size:20px;
line-height:1;color:var(--humo);padding:4px 8px}
.c1-panel-lista{overflow-y:auto;padding:6px clamp(16px,4vw,28px) 10px}
.c1-item{display:flex;align-items:center;gap:10px;padding:11px 0;
border-bottom:1px solid rgba(30,77,43,.1)}
.c1-item-dat{flex:1;min-width:0}
.c1-item-dat b{display:block;font-size:12.5px;font-weight:600;line-height:1.25;
color:var(--verde-hondo)}
.c1-item-dat span{display:block;font-size:9.5px;color:var(--humo);font-weight:600;
letter-spacing:.06em;margin-top:2px;font-variant-numeric:tabular-nums}
.c1-cant{display:flex;align-items:center;gap:2px;flex:0 0 auto}
.c1-cant button{width:28px;height:28px;border-radius:50%;border:1px solid rgba(30,77,43,.25);
background:#fff;color:var(--verde-hondo);font-size:15px;font-weight:700;cursor:pointer;
line-height:1;display:flex;align-items:center;justify-content:center}
.c1-cant button:hover{background:var(--verde);color:#fff;border-color:var(--verde)}
.c1-cant span{min-width:26px;text-align:center;font-size:13px;font-weight:700;
font-variant-numeric:tabular-nums}
.c1-item-pre{flex:0 0 auto;width:62px;text-align:right;font-size:13px;font-weight:700;
font-variant-numeric:tabular-nums;color:var(--verde-hondo)}
.c1-quitar{flex:0 0 auto;background:none;border:1px solid rgba(30,77,43,.22);
border-radius:20px;cursor:pointer;padding:5px 10px;color:var(--naranja);
display:flex;align-items:center;gap:4px;font-size:10px;font-weight:800;
letter-spacing:.08em;text-transform:uppercase;font-family:inherit}
.c1-quitar:hover{color:var(--naranja)}
.c1-panel-pie{padding:12px clamp(16px,4vw,28px);
padding-bottom:calc(12px + env(safe-area-inset-bottom));
border-top:1px solid rgba(30,77,43,.14);display:flex;align-items:center;gap:14px}
.c1-panel-pie .tot{font-size:20px;font-weight:700;letter-spacing:-.02em;
font-variant-numeric:tabular-nums;color:var(--verde-hondo)}
.c1-panel-pie .tot span{display:block;font-size:10.5px;font-weight:600;color:var(--humo);
letter-spacing:.04em}
.c1-panel-pie .ir{margin-left:auto;background:var(--naranja);color:#fff;border:none;
border-radius:30px;padding:13px 24px;font-size:11px;font-weight:800;letter-spacing:.14em;
text-transform:uppercase;cursor:pointer}
.c1-panel-pie .ir:hover{background:var(--verde-hondo)}
.c1-velo{position:fixed;inset:0;z-index:60;background:rgba(14,42,23,.45)}
            `}</style>

            <header className="c1-portada">
                <div className="c1-portada-in">
                    <span className="c1-eti">Catálogo · Los más vendidos</span>
                    <h1>Maderas <em>La Romanilla.</em></h1>
                    <p className="sub">Toca una familia y ve directo. Agregas lo que necesitas,
                    envías el pedido y te confirmamos por WhatsApp.</p>
                    <nav className="c1-indice">
                        {PAGINAS.map((pg) => (
                            <button key={pg.folio} className="c1-ind" type="button" onClick={() => irA(pg.folio)} data-testid={`c1-ind-${pg.folio}`}>
                                <span className="n">{pg.folio}</span>
                                <span className="t"><b>{pg.titulo[0]}{pg.titulo[1]}</b>
                                    <span>{pg.sello}{pg.famSkus.filter((s) => porSku[s]).length ? ` · ${pg.famSkus.filter((s) => porSku[s]).length} modelos` : ""}</span></span>
                                <span className="r">{rangoDe(pg.famSkus)}</span>
                                <span className="fl">→</span>
                            </button>
                        ))}
                    </nav>
                </div>
            </header>

            <nav className="c1-nav" data-testid="c1-nav">
                {PAGINAS.map((pg) => (
                    <button key={pg.folio} type="button" onClick={() => irA(pg.folio)}>{pg.folio} · {pg.badge}</button>
                ))}
            </nav>

            {PAGINAS.map((pg, pi) => (
                <div key={pg.folio} id={`pag-${pg.folio}`}>
                    <div className="c1-pag" style={{ "--pc1": pg.panel.c1, "--pc2": pg.panel.c2, "--pc3": pg.panel.c3, "--phondo": pg.panel.hondo }}>
                        <div className="c1-txt-panel">
                            <div className="c1-cabeza">
                                <div className="c1-badge">{pg.badge}</div>
                                <div className="c1-sello"><b>{pg.sello}</b><span>Maderas La Romanilla</span></div>
                            </div>

                            <div className="c1-txt">
                                <h1>{pg.titulo[0]}<em>{pg.titulo[1]}</em></h1>
                                <p className="c1-dice">{pg.dice}</p>
                                <div className="c1-disp" data-testid={`c1-disp-${pg.folio}`}>
                                    {pg.famSkus.filter((s) => porSku[s]).length
                                        ? `Disp.: ${pg.famSkus.filter((s) => porSku[s]).length} modelos`
                                        : "—"}
                                </div>
                                <div className="c1-ref"><b>REF.:</b><span data-testid={`c1-rango-${pg.folio}`}>{rangoDe(pg.famSkus)}</span>
                                    <i>+ IVA · al detal · al mayor −12% desde 12 unidades</i></div>

                                <div className="c1-lista">
                                    {pg.destacadas.map((d, i) => {
                                        const p = porSku[d.sku];
                                        if (!p) return null;
                                        return (
                                            <div className="c1-li" key={d.sku}>
                                                <span className="c1-let">{"ABC"[i]}</span>
                                                <span className="c1-chip" style={{ background: d.chip }} />
                                                <div className="c1-dat"><b>{d.nombre}</b><span>{p.unidad_venta || p.sku}{p.rendimiento ? ` · ${p.rendimiento}` : ""}</span></div>
                                                <span className="c1-pre">{fmt(p.precio_usd)}<small className="c1-iva">+ IVA</small></span>
                                                {botonAgregar(p)}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="c1-puestos">
                                {pg.destacadas.map((d, i) => (
                                    <figure className="c1-pu" key={d.sku}>
                                        <span className="c1-pu-let">{"ABC"[i]}</span>
                                        <img src={IMG(d.puesto)} alt={d.nombre} style={{ objectPosition: d.pos }} loading={pi === 0 && i === 0 ? "eager" : "lazy"} />
                                    </figure>
                                ))}
                            </div>
                        </div>

                        <div className="c1-img-panel">
                            <img className="c1-foto" src={IMG(pg.hero)} alt={pg.heroAlt}
                                style={{ objectPosition: pg.heroPos }} loading={pi === 0 ? "eager" : "lazy"} />
                            <div className="c1-folio">{pg.folio}</div>
                        </div>
                    </div>

                    {pg.tira.length > 0 && (
                        <section className="c1-tira">
                            <div className="c1-tira-cab">
                                <div className="c1-eti">{pg.tiraTitulo}</div>
                                <Link to="/tienda">Ver toda la tienda →</Link>
                            </div>
                            <div className="c1-rej">
                                {pg.tira.map((t) => {
                                    const p = porSku[t.sku];
                                    if (!p) return null;
                                    return (
                                        <article className="c1-pz" key={t.sku}>
                                            <div className="c1-pz-img">
                                                <img src={IMG(`catalogo/recorte/${t.sku}.png`)} alt={t.nombre} loading="lazy" />
                                            </div>
                                            <div className="c1-pz-pie">
                                                <div className="c1-pz-col"><i style={{ background: t.chip }} />{t.nombre}</div>
                                                <div className="c1-pz-ref">{p.unidad_venta || p.sku}{p.rendimiento ? ` · ${p.rendimiento}` : ""}</div>
                                                <div className="c1-pz-fila">
                                                    <span className="c1-pz-pre">{fmt(p.precio_usd)}<small className="c1-iva">+ IVA</small></span>
                                                    {botonAgregar(p)}
                                                </div>
                                            </div>
                                        </article>
                                    );
                                })}
                            </div>
                        </section>
                    )}

                    {pi === 0 && (
                        <section className="c1-como">
                            <div className="c1-como-in">
                                <div>
                                    <span className="c1-eti">Cómo funciona</span>
                                    <h3>El pedido lo armas aquí.<br /><em>Nosotros te lo confirmamos.</em></h3>
                                    <p>Tocas <b>Agregar</b> en lo que necesitas y envías el pedido: llega
                                    directo a la tienda y te confirmamos por WhatsApp. Pagas como prefieras:</p>
                                </div>
                                <div className="c1-pagos">
                                    {PAYMENT_METHODS.map((m) => <span key={m.id}>{m.label}</span>)}
                                </div>
                            </div>
                        </section>
                    )}
                </div>
            ))}

            <div className="c1-fin">
                <b>Maderas <em>La Romanilla.</em></b>
                <p>Maderas La Romanilla C.A. · RIF J-00353907-4</p>
                <p>El Llanito · envío a toda Venezuela · retiro en tienda · WhatsApp 0422-0800620</p>
                <Link to="/tienda">Ver toda la tienda →</Link>
            </div>

            {count > 0 && (
                <div className="c1-barra" data-testid="c1-barra">
                    <div>
                        <div className="c1-tot">{fmt(subtotal)}<small className="c1-iva">+ IVA</small></div>
                        <button className="c1-ver" onClick={() => setVerCarrito(true)} data-testid="c1-ver-pedido">
                            {count} producto{count > 1 ? "s" : ""} · ver y editar
                        </button>
                    </div>
                    <button className="c1-ir" onClick={() => nav("/checkout")}>Procesar pedido</button>
                </div>
            )}

            {/* Resumen editable: quitar o cambiar cantidades sin salir del catálogo */}
            {verCarrito && count > 0 && (
                <>
                    <div className="c1-velo" onClick={() => setVerCarrito(false)} />
                    <div className="c1-panel" data-testid="c1-panel-pedido">
                        <div className="c1-panel-cab">
                            <b>Tu pedido</b>
                            <button onClick={() => setVerCarrito(false)} aria-label="Cerrar">×</button>
                        </div>
                        <div className="c1-panel-lista">
                            {items.map((it) => (
                                <div className="c1-item" key={it.product.id}>
                                    <div className="c1-item-dat">
                                        <b>{it.product.nombre}</b>
                                        <span>{it.product.sku} · {fmt(unitPrice(it.product, it.quantity))} c/u + IVA</span>
                                    </div>
                                    <div className="c1-cant">
                                        <button onClick={() => updateQty(it.product.id, it.quantity - 1)} aria-label="Quitar uno">−</button>
                                        <span>{it.quantity}</span>
                                        <button onClick={() => updateQty(it.product.id, it.quantity + 1)} aria-label="Agregar uno">+</button>
                                    </div>
                                    <div className="c1-item-pre">{fmt(unitPrice(it.product, it.quantity) * it.quantity)}</div>
                                    <button className="c1-quitar" onClick={() => removeItem(it.product.id)}
                                        data-testid={`c1-quitar-${it.product.sku}`} aria-label={`Quitar ${it.product.nombre}`}>
                                        <Trash2 size={14} /> Quitar
                                    </button>
                                </div>
                            ))}
                        </div>
                        <div className="c1-panel-pie">
                            <div className="tot">{fmt(subtotal)}<span>Total del pedido · + IVA</span></div>
                            <button className="ir" onClick={() => nav("/checkout")}>Procesar pedido</button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
